import { Grid, useMediaQuery } from "@material-ui/core";
import Table from "components/Table";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { Cell } from "react-table";
import { RootState } from "redux/rootReducer";
import { getReportDateSelector } from "redux/user/user";
import { loadYieldPerTimespans } from "redux/yieldPerTimespan/yieldPerTimespanFunctions";
import { VisibleSections } from "types/VisibleSections";
import { YieldPerTimespan } from "types/YieldPerTimespan";
import { asPercent } from "utility/numbers";

const YieldPerTimespanTable = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const matchesMediaQuery = useMediaQuery("(min-width: 960px)");

  const reportControlId = useSelector((state: RootState) => state.user.reportControlId);
  const reportDate = useSelector(getReportDateSelector);

  const yieldPerTimespan = useSelector(
    (state: RootState) => state.yieldPerTimespan.all?.data ?? []
  );
  const loading = useSelector((state: RootState) => state.yieldPerTimespan.all?.loading);

  const showIndex = useSelector(
    (state: RootState) =>
      (state.user.visibleSections?.data as VisibleSections | undefined)?.NaytaTuotto ?? false
  );

  React.useEffect(() => {
    if (reportControlId && reportDate) {
      dispatch(loadYieldPerTimespans(reportControlId, reportDate, showIndex));
    }
  }, [dispatch, reportControlId, reportDate, showIndex]);

  const yieldPerTimespanColumns = [
    {
      Header: t("period"),
      accessor: "Jakso",
      whiteSpace: "nowrap",
      paddingRight: "10px",
    },
    {
      Header: t("wealth"),
      accessor: "Salkku",
      whiteSpace: "nowrap",
      paddingRight: "10px",
      minWidth: 100,
      Cell: (cell: Cell<YieldPerTimespan, number>) => asPercent(cell.value, undefined, true),
      textAlign: "right",
      fontFamily: "Lato light",
    },
    {
      Header: t("index"),
      accessor: "Indeksi",
      whiteSpace: "nowrap",
      paddingRight: "10px",
      minWidth: 100,
      Cell: (cell: Cell<YieldPerTimespan, number>) => asPercent(cell.value, undefined, true),
      textAlign: "right",
      fontFamily: "Lato light",
    },
    {
      Header: t("difference"),
      accessor: "Erotus",
      whiteSpace: "nowrap",
      minWidth: 100,
      Cell: (cell: Cell<YieldPerTimespan, number>) => asPercent(cell.value, undefined, true),
      textAlign: "right",
      fontFamily: "Lato light",
    },
  ];

  return (
    <Grid
      item
      md={6}
      sm={12}
      style={{
        padding: matchesMediaQuery ? "0 0 16px 16px" : "0 16px 16px 16px",
        overflowY: "hidden",
      }}
    >
      <Table
        data={yieldPerTimespan}
        columns={
          showIndex
            ? yieldPerTimespanColumns
            : yieldPerTimespanColumns.filter(
                (x) => x.accessor !== "Indeksi" && x.accessor !== "Erotus"
              )
        }
        loading={loading}
      />
    </Grid>
  );
};

export default React.memo(YieldPerTimespanTable);
